
export let storeSchedule = (device) => {
    return {
        type: "Schedule_Store",
        payload: {
            device
        }
    }
}